/**
 * @generated SignedSource<<4189fb12cc13a30dcdf791a62645e29a>>
 * @relayHash ee3591c22897e766ec477c244c1b1f68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 067ac770c9e81359b4445020b13338260b439942ac378ec776736f49010e2777

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewNewQuery } from './SupportWebsiteOverviewNewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewNewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "067ac770c9e81359b4445020b13338260b439942ac378ec776736f49010e2777",
    "metadata": {},
    "name": "SupportWebsiteOverviewNewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
